import React from "react"
import PropTypes from "prop-types"
import InfoDataPanel from "src/v2/components/InfoDataPanel/info-data-panel"
import { formatDateString } from "src/utils/format-date"

const formatDate = (date) => formatDateString(date, "-")

const formatValue = (value) => {
    if (!value) return "-"

    try {
        return new Intl.NumberFormat("pt-BR").format(value)
    } catch {
        return "-"
    }
}

const leftItems = [
    {
        key: "CETIP",
        label: "Cetip",
        gridProps: { xxxs: 2, xs: 2, md: 6, lg: 6 },
    },
    {
        key: "ISIN",
        label: "ISIN",
        gridProps: { xxxs: 2, xs: 2, md: 6, lg: 6 },
    },
    {
        key: "Serie",
        label: "Série",
        gridProps: { xxxs: 2, xs: 2, md: 6, lg: 6 },
    },
    {
        key: "Emissao",
        label: "Emissão",
        gridProps: { xxxs: 2, xs: 2, md: 6, lg: 6 },
    },
    {
        key: "DataDocumento",
        label: "Data Documento",
        formatter: formatDate,
        gridProps: { xxxs: 2, xs: 2, md: 6, lg: 6 },
    },
    {
        key: "VersaoDocumento",
        label: "Versão Documento",
        gridProps: { xxxs: 2, xs: 2, md: 6, lg: 6 },
    },
    {
        key: "TipoAtivo",
        label: "Tipo Ativo",
        gridProps: { xxxs: 2, xs: 2, md: 6, lg: 6 },
    },
    {
        key: "Incentivada",
        label: "Incentivada",
        gridProps: { xxxs: 2, xs: 2, md: 6, lg: 6 },
    },
    {
        key: "Indexador",
        label: "Indexador",
        gridProps: { xxxs: 2, xs: 2, md: 6, lg: 6 },
    },
    {
        key: "Remuneracao",
        label: "Remuneração",
        gridProps: { xxxs: 2, xs: 2, md: 6, lg: 6 },
    },
    {
        key: "CotaSubordinacao",
        label: "Cota Subordinação",
        gridProps: { xxxs: 2, xs: 2, md: 6, lg: 6 },
    },
    {
        key: "TipoOferta",
        label: "Tipo Oferta",
        gridProps: { xxxs: 2, xs: 2, md: 6, lg: 6 },
    },
]

const sections = [
    {
        items: [
            {
                key: "DataEmissao",
                label: "Data Emissão",
                formatter: formatDate,
            },
            {
                key: "DataPrimeiraIntegralizacao",
                label: "Data 1ª Integralização",
                formatter: formatDate,
            },
            {
                key: "DataVencimento",
                label: "Data Vencimento",
                formatter: formatDate,
            },
            {
                key: "DataResgateAntecipado",
                label: "Data Resgate antecipado",
                formatter: formatDate,
            },
        ],
    },
    {
        items: [
            {
                key: "DataCarenciaResgate",
                label: "Data Carência Resgate",
                formatter: formatDate,
            },
            {
                key: "DataResgateAntecipado",
                label: "Data Resgate Antecipado",
                formatter: formatDate,
            },
            {
                key: "FrequenciaJuros",
                label: "Frequência Juros",
                formatter: formatValue,
            },
            {
                key: "FrequenciaAmortizacao",
                label: "Frequência Amortização",
                formatter: formatValue,
            },
        ],
    },
    {
        items: [
            {
                key: "Conversabilidade",
                label: "Conversabilidade",
                formatter: formatValue,
            },
            {
                key: "Green",
                label: "Green",
                formatter: formatValue,
            },
            {
                key: "Lei12431",
                label: "Lei 12.431",
                formatter: formatValue,
            },
            {
                key: "Lei14801",
                label: "Lei 14.801",
                formatter: formatValue,
            },
        ],
    },
    {
        items: [
            {
                key: "PrePagamento",
                label: "Pré Pagamento",
                formatter: formatDate,
            },
            {
                key: "LiquidezDiaria",
                label: "Liquidez Diária",
                formatter: formatValue,
            },
            {
                key: "RepactuacaoCredito",
                label: "Repactuação Crédito",
                formatter: formatValue,
            },
            {
                key: "ResgateAntecipado",
                label: "Resgate Antecipado",
                formatter: formatValue,
            },
        ],
    },
    {
        items: [
            {
                key: "PU_Emissao",
                label: "Pu Emissão",
                formatter: formatValue,
            },
            {
                key: "QuantidadeEmitida",
                label: "Quantidade Emitida",
                formatter: formatValue,
            },
            {
                key: "ValorSerie",
                label: "Valor Série",
                formatter: formatValue,
            },
            {
                key: "ValorTotalEmissao",
                label: "Valor Total Emissão",
                formatter: formatValue,
            },
        ],
    },
    {
        items: [
            {
                key: "SpreadEmissao",
                label: "Spread Emissão",
                formatter: formatValue,
            },
            {
                key: "DurationEmissao",
                label: "Duração Emissão",
                formatter: formatValue,
            },
            {
                key: "PrazoEmissao",
                label: "Prazo Emissão",
                formatter: formatValue,
            },
            {
                key: "Perpetuidade",
                label: "Perpetuidade",
                formatter: formatValue,
            },
        ],
    },
]

const bottomItems = [
    {
        key: "DestinacaoRecursos",
        label: "Destinação de Recursos",
    },
]

export const DataEmissionPanel = ({ characterData }) => {
    return (
        <InfoDataPanel
            data={characterData}
            leftItems={leftItems}
            sections={sections}
            bottomItems={bottomItems}
        />
    )
}

DataEmissionPanel.propTypes = {
    characterData: PropTypes.object,
}